import axios from 'axios';
import { addClientFilteringMetaData } from '../generators/filteringMetaDataGenerator';

export function fetchClients() {
    return axios.get('/clients').then((clients) => {
        addFilteringMetadata(clients.data);
        addClientStatusToWebsites(clients.data);
        return clients;
    });
}

export function postLabels(labels) {
    return axios.post('/labels', labels).then((labels) => {
        return labels;
    });
}

export function impersonate(data) {
    return axios.post('/clients/impersonate', data).then((response) => response.data);
}

export function breakClientRelation(id) {
    return axios.post(`/clients/break/${id}`);
}

function addFilteringMetadata(items) {
    for (var i = 0; i < items.length; i++) addClientFilteringMetaData(items[i]);
}

function addClientStatusToWebsites(items) {
    for (var i = 0; i < items.length; i++) {
        var client = items[i];

        for (var j = 0; j < client.websites.length; j++)
            client.websites[j].parentStatus = client.status;
    }
}
